// extracted by mini-css-extract-plugin
export var play = "Video-module--play--FDcIk";
export var playIcon = "Video-module--playIcon--ITl27";
export var player = "Video-module--player--x1xsN";
export var playing = "Video-module--playing--BI7ZY";
export var previewImage = "Video-module--previewImage--MZKDG";
export var root = "Video-module--root--ZEjbv";